export class EmployeeInterest {
    constructor({
        id,
        firstName,
        lastName,
        email,
        phoneNumber,
        positionType,
        preferredStore,
        interestArea,
        startDate,
        hoursPerWeek,
        yearsOfExperience,
        priorExperience,
        resumeUrl,
        status = 'pending',
        statusHistory = [],
        createdAt,
    }) {
        this.id = id;
        this.firstName = firstName || '';
        this.lastName = lastName || '';
        this.email = email || '';
        this.phoneNumber = phoneNumber || '';
        this.positionType = positionType || '';
        this.preferredStore = preferredStore || '';
        this.interestArea = interestArea || '';
        this.startDate = startDate || '';
        this.hoursPerWeek = hoursPerWeek || '';
        this.yearsOfExperience = yearsOfExperience || '';
        this.priorExperience = priorExperience || '';
        this.resumeUrl = resumeUrl || '';
        this.status = status || 'pending';
        this.statusHistory = statusHistory || [];
        this.createdAt = createdAt || '';
    }

    get fullName() {
        return `${this.firstName} ${this.lastName}`.trim();
    }

    toJson() {
        return {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            phoneNumber: this.phoneNumber,
            positionType: this.positionType,
            preferredStore: this.preferredStore,
            interestArea: this.interestArea,
            startDate: this.startDate,
            hoursPerWeek: this.hoursPerWeek,
            yearsOfExperience: this.yearsOfExperience,
            priorExperience: this.priorExperience,
            resumeUrl: this.resumeUrl,
            status: this.status,
            statusHistory: this.statusHistory,
            createdAt: this.createdAt,
        };
    }

    static fromFirebase(doc) {
        const data = doc.data();
        // createdAt may be a Firestore Timestamp or an ISO string
        let createdAt = data.createdAt || '';
        if (createdAt && typeof createdAt.toDate === 'function') {
            createdAt = createdAt.toDate().toISOString();
        }
        return new EmployeeInterest({
            id: doc.id,
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            email: data.email || '',
            phoneNumber: data.phoneNumber || '',
            positionType: data.positionType || '',
            preferredStore: data.preferredStore || '',
            interestArea: data.interestArea || '',
            startDate: data.startDate || '',
            hoursPerWeek: data.hoursPerWeek || '',
            yearsOfExperience: data.yearsOfExperience || '',
            priorExperience: data.priorExperience || '',
            resumeUrl: data.resumeUrl || '',
            status: data.status || 'pending',
            statusHistory: data.statusHistory || [],
            createdAt,
        });
    }
}
